// src/components/subcontractors/subcontractorsData.js

export const SPECIALTY_TAGS = [
  { id: 'ppf',              label: 'PPF',                color: '#2E8BF0' },
  { id: 'vinyl',            label: 'Vinyl Wrap',         color: '#8B5CF6' },
  { id: 'ceramic',          label: 'Ceramic Coating',    color: '#10B981' },
  { id: 'tint',             label: 'Window Tint',        color: '#64748B' },
  { id: 'paint_correction', label: 'Paint Correction',   color: '#F59E0B' },
  { id: 'powder_coat',      label: 'Powder Coating',     color: '#EF4444' },
  { id: 'fabrication',      label: 'Custom Fabrication', color: '#EC4899' },
  { id: 'detailing',        label: 'Detailing',          color: '#06B6D4' },
];

// Matches the 8-color palette used in Settings.jsx UserProfilePage
export const AVATAR_COLORS = [
  '#2563eb','#7c3aed','#db2777','#dc2626',
  '#d97706','#16a34a','#0891b2','#64748b',
];

const now = new Date();
const daysAgo  = (n) => new Date(now - n * 86_400_000).toISOString();
const daysFrom = (n) => new Date(+now + n * 86_400_000).toISOString();

export const SEED_SUBCONTRACTORS = [
  {
    id: 'sub-001', name: 'Jose Barajas', company: 'Barajas Pro Wraps',
    avatarColor: '#2563eb', avatarUrl: null,
    phone: '(512) 847-2930', email: 'jose@barajaspro.com',
    address: '1204 Lamar Blvd, Austin TX 78703',
    website: 'https://barajaspro.com', instagram: '@barajaspro',
    specialties: ['ppf', 'vinyl', 'ceramic'],
    defaultRate: { type: 'flat', amount: 1200, currency: 'USD' },
    status: 'active',
    notes: 'Reliable installer. Brings own tools. Prefers morning starts.',
    createdAt: daysAgo(180), updatedAt: daysAgo(3),
  },
  {
    id: 'sub-002', name: 'Maria Chen', company: 'Chen Detail Studio',
    avatarColor: '#7c3aed', avatarUrl: null,
    phone: '(512) 334-8812', email: 'maria@chenstudio.com',
    address: '840 Congress Ave, Austin TX 78701',
    website: null, instagram: '@chenstudio',
    specialties: ['tint', 'paint_correction'],
    defaultRate: { type: 'hourly', amount: 75, currency: 'USD' },
    status: 'active',
    notes: 'Meticulous finish work. Books 1 week in advance.',
    createdAt: daysAgo(120), updatedAt: daysAgo(10),
  },
  {
    id: 'sub-003', name: 'Derek Thompson', company: 'Thompson Fab Works',
    avatarColor: '#16a34a', avatarUrl: null,
    phone: '(737) 221-5509', email: 'derek@thompsonfab.com',
    address: '3300 Esperanza Crossing, Austin TX 78758',
    website: 'https://thompsonfab.com', instagram: null,
    specialties: ['fabrication', 'powder_coat'],
    defaultRate: { type: 'per_vehicle', amount: 2500, currency: 'USD' },
    status: 'active',
    notes: 'Custom bumpers and sliders. Lead time 10–14 days.',
    createdAt: daysAgo(90), updatedAt: daysAgo(5),
  },
  {
    id: 'sub-004', name: 'Sofia Reyes', company: 'Reyes PPF Solutions',
    avatarColor: '#db2777', avatarUrl: null,
    phone: '(512) 601-4477', email: 'sofia@reyesppf.com',
    address: null, website: null, instagram: '@reyesppf',
    specialties: ['ppf', 'ceramic'],
    defaultRate: { type: 'per_panel', amount: 85, currency: 'USD' },
    status: 'inactive',
    notes: 'On leave through May. Excellent quality when available.',
    createdAt: daysAgo(200), updatedAt: daysAgo(30),
  },
  {
    id: 'sub-005', name: 'Brandon Willis', company: 'Willis Auto Detail',
    avatarColor: '#64748b', avatarUrl: null,
    phone: '(512) 988-3241', email: 'brandon@willisdetail.com',
    address: '9900 US-183, Austin TX 78759',
    website: null, instagram: null,
    specialties: ['detailing', 'vinyl'],
    defaultRate: { type: 'flat', amount: 600, currency: 'USD' },
    status: 'blacklisted',
    notes: 'No-showed on 2 jobs. Do not rebook.',
    createdAt: daysAgo(300), updatedAt: daysAgo(60),
  },
];

export const SEED_JOBS = [
  // Jose — in_progress (partial pay), scheduled (no pay), completed (fully paid)
  {
    id: 'job-001', subcontractorId: 'sub-001',
    linkType: 'standalone', estimateId: null, workOrderId: null,
    customerName: 'Marcus Bell', vehicleLabel: '2023 Tesla Model 3',
    projectRef: 'WM-0041', scope: 'Full front clip PPF — hood, fenders, bumper, mirrors',
    agreedPrice: 1200, status: 'in_progress',
    scheduledDate: daysAgo(4), completedDate: null,
    payments: [{
      id: 'pay-001', amount: 600, method: 'zelle', date: daysAgo(4),
      reference: '#4821', notes: 'Deposit', recordedAt: daysAgo(4), recordedBy: 'Alex R.',
    }],
    review: null, createdAt: daysAgo(10), updatedAt: daysAgo(4),
  },
  {
    id: 'job-002', subcontractorId: 'sub-001',
    linkType: 'standalone', estimateId: null, workOrderId: null,
    customerName: 'Priya Nair', vehicleLabel: '2022 BMW M3',
    projectRef: 'WM-0044', scope: 'Full body vinyl color change — Satin Battleship Grey',
    agreedPrice: 2800, status: 'scheduled',
    scheduledDate: daysFrom(5), completedDate: null,
    payments: [], review: null, createdAt: daysAgo(3), updatedAt: daysAgo(3),
  },
  {
    id: 'job-003', subcontractorId: 'sub-001',
    linkType: 'standalone', estimateId: null, workOrderId: null,
    customerName: 'David Kim', vehicleLabel: '2021 Porsche 911',
    projectRef: 'WM-0038', scope: 'Ceramic Pro 9H full exterior application',
    agreedPrice: 1800, status: 'completed',
    scheduledDate: daysAgo(20), completedDate: daysAgo(18),
    payments: [
      { id: 'pay-002', amount: 900, method: 'venmo', date: daysAgo(20), reference: '', notes: 'Deposit', recordedAt: daysAgo(20), recordedBy: 'Alex R.' },
      { id: 'pay-003', amount: 900, method: 'venmo', date: daysAgo(18), reference: '', notes: 'Final', recordedAt: daysAgo(18), recordedBy: 'Alex R.' },
    ],
    review: { rating: 5, notes: 'Flawless application. Customer thrilled.', wouldRehire: true, reviewedAt: daysAgo(17) },
    createdAt: daysAgo(25), updatedAt: daysAgo(17),
  },
  // Maria — in_progress (no pay = overdue), completed (paid)
  {
    id: 'job-004', subcontractorId: 'sub-002',
    linkType: 'standalone', estimateId: null, workOrderId: null,
    customerName: 'Rachel Torres', vehicleLabel: '2020 Cadillac Escalade',
    projectRef: 'WM-0043', scope: 'Full windshield + 4 windows — 35% ceramic tint',
    agreedPrice: 450, status: 'in_progress',
    scheduledDate: daysAgo(9), completedDate: null,
    payments: [], review: null, createdAt: daysAgo(12), updatedAt: daysAgo(9),
  },
  {
    id: 'job-005', subcontractorId: 'sub-002',
    linkType: 'standalone', estimateId: null, workOrderId: null,
    customerName: 'James Okafor', vehicleLabel: '2019 Dodge Challenger',
    projectRef: 'WM-0036', scope: 'Stage 2 paint correction — full exterior',
    agreedPrice: 1100, status: 'completed',
    scheduledDate: daysAgo(35), completedDate: daysAgo(33),
    payments: [{ id: 'pay-004', amount: 1100, method: 'cash', date: daysAgo(33), reference: '', notes: '', recordedAt: daysAgo(33), recordedBy: 'Tim W.' }],
    review: { rating: 4.5, notes: 'Excellent cut and polish. Paint looks new.', wouldRehire: true, reviewedAt: daysAgo(32) },
    createdAt: daysAgo(40), updatedAt: daysAgo(32),
  },
  // Derek — in_progress (partial pay), completed (paid)
  {
    id: 'job-006', subcontractorId: 'sub-003',
    linkType: 'standalone', estimateId: null, workOrderId: null,
    customerName: 'Carlos Mendez', vehicleLabel: '2022 Ford Bronco',
    projectRef: 'WM-0040', scope: 'Custom steel front bumper + side sliders — powder coated black',
    agreedPrice: 3200, status: 'in_progress',
    scheduledDate: daysAgo(5), completedDate: null,
    payments: [{ id: 'pay-005', amount: 1600, method: 'check', date: daysAgo(5), reference: 'CHK-4499', notes: '50% deposit', recordedAt: daysAgo(5), recordedBy: 'Tim W.' }],
    review: null, createdAt: daysAgo(8), updatedAt: daysAgo(5),
  },
  {
    id: 'job-007', subcontractorId: 'sub-003',
    linkType: 'standalone', estimateId: null, workOrderId: null,
    customerName: 'Amy Nguyen', vehicleLabel: '2021 Jeep Gladiator',
    projectRef: 'WM-0031', scope: 'Roof rack fabrication + powder coat — gloss black',
    agreedPrice: 1400, status: 'completed',
    scheduledDate: daysAgo(50), completedDate: daysAgo(47),
    payments: [{ id: 'pay-006', amount: 1400, method: 'zelle', date: daysAgo(47), reference: '#7730', notes: '', recordedAt: daysAgo(47), recordedBy: 'Alex R.' }],
    review: { rating: 4, notes: 'Solid work. Slight delay but quality was great.', wouldRehire: true, reviewedAt: daysAgo(46) },
    createdAt: daysAgo(55), updatedAt: daysAgo(46),
  },
  // Sofia — completed (paid, low rating)
  {
    id: 'job-008', subcontractorId: 'sub-004',
    linkType: 'standalone', estimateId: null, workOrderId: null,
    customerName: 'Michael Strauss', vehicleLabel: '2020 Mercedes C63 AMG',
    projectRef: 'WM-0027', scope: 'Full PPF — hood, roof, trunk lid, A/B/C pillars',
    agreedPrice: 2200, status: 'completed',
    scheduledDate: daysAgo(70), completedDate: daysAgo(68),
    payments: [
      { id: 'pay-007', amount: 1100, method: 'venmo', date: daysAgo(70), reference: '', notes: 'Deposit', recordedAt: daysAgo(70), recordedBy: 'Tim W.' },
      { id: 'pay-008', amount: 1100, method: 'venmo', date: daysAgo(68), reference: '', notes: '', recordedAt: daysAgo(68), recordedBy: 'Tim W.' },
    ],
    review: { rating: 3.5, notes: 'Good finish but took longer than quoted. Communication could improve.', wouldRehire: false, reviewedAt: daysAgo(67) },
    createdAt: daysAgo(75), updatedAt: daysAgo(67),
  },
  // Brandon — one archived (cancelled) job so the History tab's archived path is exercised
  {
    id: 'job-009', subcontractorId: 'sub-005',
    linkType: 'standalone', estimateId: null, workOrderId: null,
    customerName: 'Tyler Ramos', vehicleLabel: '2018 Chevy Silverado',
    projectRef: 'WM-0019', scope: 'Full vinyl wrap — Matte Black',
    agreedPrice: 1800, status: 'archived',
    scheduledDate: daysAgo(90), completedDate: null,
    payments: [], review: null, createdAt: daysAgo(95), updatedAt: daysAgo(88),
  },
];

export const SEED_REMINDERS = [
  {
    id: 'rem-001', subcontractorId: 'sub-001', jobId: 'job-001',
    title: 'Follow up — Tesla final payment ($600 owed)',
    dueDate: daysFrom(3), done: false, createdAt: daysAgo(1),
  },
  {
    id: 'rem-002', subcontractorId: 'sub-003', jobId: 'job-006',
    title: 'Confirm Bronco bumper delivery date with Derek',
    dueDate: daysFrom(1), done: false, createdAt: daysAgo(2),
  },
];
